import camelCaseKeys, { CamelCaseKeys } from 'camelcase-keys';

export function toCamelCaseObj<TData extends Record<string, unknown>>(
  obj: TData
) {
  return camelCaseKeys(obj, {
    deep: true,
    preserveConsecutiveUppercase: true,
  }) as CamelCaseKeys<TData, true, false, true>;
}
